import { NgModule } from '@angular/core';
import { LetterListComponent } from './letter-list.component';

@NgModule({
  declarations: [LetterListComponent],
})
export class LetterListModule { }
